export default "__VITE_ASSET__DLPsImNK__"